import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MenuItem} from 'src/app/app.models';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/services/auth.service';
import { HostService } from 'src/app/services/host.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { PaymentService } from "src/app/services/payment.service";
import { TransferService } from "src/app/services/transfer.service";

@Component({
  selector: 'app-view-user',
  templateUrl: './view-user.component.html',
  styleUrls: ['./view-user.component.scss']
})
export class ViewUserComponent implements OnInit {

  private sub: any;
  public menuItem!: MenuItem;
  currentAmount: number;
  currentAmountGetted: boolean;

  idUser: number;

  //Subscription
  infoUserSubscription: Subscription
  changeProfilSubscription: Subscription;
  deleteSubsciption: Subscription;
  sumIncome: Subscription;
  sumTransfer : Subscription;
  
  //boolean
  profilChanged: boolean = false;
  deleted: boolean = false;
  sumGetted: boolean;
  sumTransferGetted: boolean;

  public user: any;
  public country: any;
  public countryCNI: any;
  revenuetotal: number;
  transferTotal : number;
  currentAmountSubscription: Subscription;
 
  currency: string;

  constructor(private appService:AppService, 
              private activatedRoute: ActivatedRoute,
              public transferService: TransferService,
              private userService: UserServiceService,
              public hostService: HostService,
              public paymentService: PaymentService,
              private toastr: ToastrService,
              private authService: AuthService,
              private router: Router) { }

  ngOnInit(): void {
    this.getCategories();
    this.sub = this.activatedRoute.params.subscribe(params => {  
      if(params['id']){
        this.getMenuItemById(params['id']); 
      } 
      else{
        this.getMenuItemById(20); 
      }
    }); 
    //this.montantactuelle();
    this.initProperty();

  }

  initProperty() {

    this.currency = this.appService.getCurrency();

    this.idUser = Number(this.activatedRoute.snapshot.queryParamMap.get("id")!);

    //console.log(this.idUser);

    this.infoUserSubscription = this.userService.getUserFind(this.idUser).subscribe((response: any) => {

      this.user = response[0];
            
      if(response[0]['driver_licenses_country'] != null) {

        this.country = this.appService.getCountries().find((country: any) => country.code == response[0]['driver_licenses_country']);

      }

      if(response[0]['cni_country'] != null) {

        this.countryCNI = this.appService.getCountries().find((country: any) => country.code == response[0]['cni_country']);

      }
      //console.log(response, this.country);

    })

 
      let obj = {
        idUser: this.idUser
      }
      //Montant actuel
      this.currentAmountSubscription = this.paymentService.currentAmount(obj).subscribe((data: any) => {
        this.currentAmount = data.value;
        this.currentAmountGetted = true;
  console.log(this.currentAmount);
      });

      //Total revenus
      this.sumIncome =  this.paymentService.sumIncome(obj).subscribe((data: any) => {
        this.revenuetotal = data.value;
        this.sumGetted = true;
      });
  
       //Total virements
       this.sumTransfer = this.transferService.sumTransfer(obj).subscribe((data: any) => {
        this.transferTotal = data.value;
        this.sumTransferGetted = true;
      })
 

  }


  public getCategories(){
    if(!this.appService.Data.categories.length){
      this.appService.getCategories().subscribe(categories=>{ 
        this.appService.Data.categories = categories;
      });
    } 
  } 

  public getMenuItemById(id:number){ 
    this.appService.getMenuItemById(id).subscribe(data=>{ 
      this.menuItem = data;  
    }); 
  }

  public changeProfil(value: string, id: number, text: string) {
    
    if(this.user.user_profil == value) {

        this.toastr.error('Veuillez séléctionner un autre profil');

    } else {

        let obj = {
            'id': id,
            'profil': value
        };

        this.changeProfilSubscription = this.userService.changeProfil(obj).subscribe((response: any) => {

            this.toastr.success("Le profil de l'utilisateur est passé à "+text);

            this.initProperty();

            this.profilChanged = true;

        })

    }

  }


  public deleteUser(id:number){

    let obj = {
        id:id
    }
    this.deleteSubsciption =  this.userService.delete(id).subscribe(user =>{
      
      if(id == this.user.id)
      {

          this.authService.logout();

      } else {

        this.router.navigate(["admin/users"]);

      }

    });
  }



  ngOnDestroy() {

    this.sub.unsubscribe();

    this.infoUserSubscription.unsubscribe();

    if(this.profilChanged) {

      this.changeProfilSubscription.unsubscribe();

    }

    if(this.deleted) {

      this.deleteSubsciption.unsubscribe();

    }
    
  } 

}
